import React from 'react';
import { Link } from 'react-router-dom';
import ProjectStatusBadge from './ProjectStatusBadge';
import TimeScopeDisplay from './TimeScopeDisplay';
import { getTypeLabel } from '../services/projectsAPI';
import AccessTagList from './AccessTagList';

/**
 * 專案卡片元件
 * @param {Object} props
 * @param {Object} props.project - 專案資料
 * @param {Function} props.onPrefetch - 預取回調函數
 */
function ProjectCard({ project, onPrefetch }) {
  const stats = project.stats || {};

  return (
    <Link
      to={`/projects/${project.id}`}
      onMouseEnter={() => onPrefetch?.(project.id)}
      className="block"
    >
      <div className="bg-white rounded-lg border border-gray-200 p-6 hover:shadow-lg hover:border-purple-300 transition-all">
        {/* 標題區域 */}
        <div className="flex items-start justify-between mb-3">
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-gray-900 mb-1">
              {project.name}
            </h3>
            <p className="text-sm text-gray-500 font-mono">{project.code}</p>
          </div>
          <ProjectStatusBadge status={project.status} />
        </div>

        {/* 專案資訊 */}
        <div className="space-y-2 mb-4">
          <div className="flex items-center text-sm text-gray-600">
            <svg
              className="w-4 h-4 mr-2"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"
              />
            </svg>
            <span>{getTypeLabel(project.project_type)}</span>
          </div>

          <TimeScopeDisplay timeScope={project.time_scope} />

          {/* 權限標籤：決定哪些使用者看得到此專案 */}
          <AccessTagList tags={project.access_tags || []} resourceLabel="此專案" />

          {project.description && (
            <p className="text-sm text-gray-600 line-clamp-2 mt-2">
              {project.description}
            </p>
          )}
        </div>

        {/* 統計資訊 */}
        <div className="grid grid-cols-3 gap-3 pt-4 border-t border-gray-100">
          <div className="text-center">
            <p className="text-xs text-gray-500">表單</p>
            <p className="text-lg font-semibold text-gray-900">
              {stats.total_forms || 0}
            </p>
          </div>
          <div className="text-center">
            <p className="text-xs text-gray-500">回覆</p>
            <p className="text-lg font-semibold text-gray-900">
              {stats.total_responses || 0}
            </p>
          </div>
          <div className="text-center">
            <p className="text-xs text-gray-500">完成率</p>
            <p className="text-lg font-semibold text-teal-600">
              {stats.completion_rate || 0}%
            </p>
          </div>
        </div>

        {/* 進度條 */}
        {stats.completion_rate !== undefined && (
          <div className="mt-4">
            <div className="w-full bg-gray-200 rounded-full h-2">
              <div
                className="bg-teal-500 h-2 rounded-full transition-all"
                style={{ width: `${stats.completion_rate}%` }}
              />
            </div>
          </div>
        )}
      </div>
    </Link>
  );
}

export default ProjectCard;
